import {
  BD_GET_OFFERSTATUS_LISTING,
  BD_GET_OFFERSTATUS_LISTING_SUCCESS,
  BD_GET_OFFERSTATUS_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    bdOfferStatus: null,
  }
  
  const bdOfferStatus = (state = initialState, action) => {
    switch (action.type) {
      case BD_GET_OFFERSTATUS_LISTING:
        state = {
          ...state,
          loading: true,
          bdOfferStatus: action.payload,
        }
        break
      case BD_GET_OFFERSTATUS_LISTING_SUCCESS:
        state = { ...state, loading: false, bdOfferStatus: action.payload }
        break
      case BD_GET_OFFERSTATUS_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default bdOfferStatus
  